module.exports = __webpack_public_path__ + "media/images/home/logo-netflix-white-0934348d17b2ad2b19405c8786cdb00f.png";